import {Col, Row} from 'antd';
import React from 'react';
import styled from 'styled-components';
import notFoundImg from './notFound.svg';

const Image = styled.img`
  max-width: 100%;
`;

const Container = styled.div`
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

const Title = styled.h1`
  color: #434e59;
  font-size: 72px;
  font-weight: 400;
  line-height: 72px;
  margin-bottom: 24px;
`;

const Content = styled.p`
  color: rgba(0, 0, 0, 0.45);
  font-size: 20px;
  line-height: 28px;
`;

export const NotFound: React.FC<{message?: string | JSX.Element}> = ({
  message = 'Sorry, the page you visited does not exist'
}) => (
  <Container>
    <Row justify="center" align="middle">
      <Col span={10}>
        <Image src={notFoundImg} alt="Not found" />
      </Col>
      <Col span={10}>
        <Title>404</Title>
        <Content>{message}</Content>
      </Col>
    </Row>
  </Container>
);
